import { render, staticRenderFns } from "./public.vue?vue&type=template&id=32f652e3&scoped=true"
import script from "./public.vue?vue&type=script&lang=js"
export * from "./public.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f652e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f652e3')) {
      api.createRecord('32f652e3', component.options)
    } else {
      api.reload('32f652e3', component.options)
    }
    module.hot.accept("./public.vue?vue&type=template&id=32f652e3&scoped=true", function () {
      api.rerender('32f652e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/public.vue"
export default component.exports